import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar"; 
import { Box } from "@mui/material";

const MainLayout = () => {
    return (
        <Box sx={{ display: "flex" }}>
            <Sidebar />
                        {/* <Navbar/> */}

            <Box sx={{ flexGrow: 1, p: 3 }}>
                <Outlet /> {/* This renders the page components */}
            </Box>
        </Box>
    );
};

export default MainLayout;
